import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import * as Type from "./type";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import { putSaga } from "src/request/put";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { deleteSaga } from "src/request/delete";

//***CANCELLATIONREASON***//
export const getCancellationReasons = createAction(
  "GET_CANCELLATION_REASON",
  ({ payload, params }: SagaActionParams<Type.CancellationReasonDto[]>) => ({
    payload,
    url: "/api/admin/cancellationreason" + (params ? params : ""),
  })
);
export const getCancellationReasonDetails = createAction(
  "GET_CANCELLATION_REASON_DETAILS",
  ({ payload, id }: SagaActionParams<Type.CancellationReasonDetailDto>) => ({
    payload,
    url: "/api/admin/cancellationreason/" + id,
  })
);
export const createCancellationReason = createAction(
  "CREATE_CANCELLATION_REASON",
  ({ payload, body }: SagaActionParams<Type.CancellationReasonDto>) => ({
    payload,
    url: "/api/admin/cancellationreason",
    body,
  })
);
export const updateCancellationReason = createAction(
  "UPDATE_CANCELLATION_REASONS",
  ({ payload, id, body }: SagaActionParams<Type.CancellationReasonDto>) => ({
    payload,
    url: "/api/admin/cancellationreason/" + id,
    body,
  })
);
export const deleteCancellationReason = createAction(
  "DELETE_CANCELLATIONREASONS",
  ({ payload, id }: SagaActionParams<Type.CancellationReasonDto>) => ({
    payload,
    url: "/api/admin/cancellationreason/" + id,
  })
);

const cancellationReasonSaga = [
  /****************CANCELLATION REASONS****************/
  takeLatest<any>(
    getCancellationReasons.toString(),
    (payload: SagaGenericParams<Type.CancellationReasonDto[]>) =>
      getSaga<Type.CancellationReasonDto[]>(payload)
  ),
  takeLatest<any>(
    getCancellationReasonDetails.toString(),
    (payload: SagaGenericParams<Type.CancellationReasonDetailDto>) =>
      getSaga<Type.CancellationReasonDetailDto>(payload)
  ),
  takeLatest<any>(
    createCancellationReason.toString(),
    (payload: SagaGenericParams<Type.CancellationReasonDetailDto>) =>
      postSaga<Type.CancellationReasonDetailDto>(payload)
  ),
  takeLatest<any>(
    updateCancellationReason.toString(),
    (payload: SagaGenericParams<Type.CancellationReasonDetailDto>) =>
      putSaga<Type.CancellationReasonDetailDto>(payload)
  ),
  takeLatest<any>(
    deleteCancellationReason.toString(),
    (payload: SagaGenericParams<any>) =>
      deleteSaga<Type.CancellationReasonDetailDto>(payload)
  ),
];

export default cancellationReasonSaga;
